module.exports = __webpack_public_path__ + "img/eq-nightwings-veil.56d8ac02.png";